import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";

import {
  Card,
  CardBody,
  Col,
  Container,
  Label,
  Row,
  Form,
  Button,
  CardTitle,
  UncontrolledTooltip,
  Input,
  FormFeedback,
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";

// Redux
import { connect, useDispatch } from "react-redux";
import { withRouter, Link, useHistory, useParams } from "react-router-dom";

// Backend
import {
  getRateFullList,
  getVehicleFullList,
  getClient,
} from "connection/backend";

// actions
import { clientUpdate } from "store/actions";

//Import Breadcrumb
import Breadcrumb from "components/Common/Breadcrumb";
import Loader from "components/Common/Loader";

const ClientUpdate = (props) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();

  const redirect = () => {
    history.push("/clients");
  };

  const [rates, setRates] = useState([]);
  const [vehicles, setVehicles] = useState([]);

  const getRateData = async () => {
    const response = await getRateFullList();
    const data = response.data;
    setRates(data);
  };

  const getVehicleData = async () => {
    const response = await getVehicleFullList();
    const data = response.data;
    setVehicles(data);
  };

  const getData = async (id) => {
    const response = await getClient(id);
    const data = response.data;
    setFormData({
      document_type: data.document_type,
      document_number: data.document_number,
      code: data.code,
      full_name: data.full_name,
      email: data.email,
      phone_number: data.phone_number,
      department: data.department,
      city: data.city,
      address: data.address,
      establishment: data.establishment,
      rate: data.rate.toString(),
      vehicle: data.vehicle ? data.vehicle.toString() : "",
    });
  };

  useEffect(() => {
    getRateData();
    getVehicleData();
    getData(id);
  }, [id]);

  const [formData, setFormData] = useState({
    document_type: "",
    document_number: "",
    code: "",
    full_name: "",
    email: "",
    phone_number: "",
    department: "",
    city: "",
    address: "",
    establishment: "",
    rate: "",
    vehicle: "",
  });

  const {
    document_type,
    document_number,
    code,
    full_name,
    email,
    phone_number,
    department,
    city,
    address,
    establishment,
    rate,
    vehicle,
  } = formData;

  const onChange = (e) => {
    if (e.target.name === "department" || e.target.name === "city") {
      setFormData({
        ...formData,
        [e.target.name]: e.target.value.toUpperCase(),
      });
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    dispatch(clientUpdate(id, formData));
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Carnesvilla | Clientes </title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title={"Carnesvilla"} breadcrumbItem={"Clientes"} />
          {props.loading ? (
            <Loader />
          ) : (
            <div className="d-flex justify-content-center">
              {props.clientUpdated.code ? (
                <SweetAlert
                  title="¡Hecho!"
                  success
                  showConfirm={true}
                  onConfirm={() => {
                    redirect();
                  }}
                >
                  Los datos del cliente <b>{props.clientUpdated.full_name}</b>{" "}
                  se ha actualizado correctamente.
                </SweetAlert>
              ) : null}
              <Card
                style={{
                  width: "70rem",
                }}
              >
                <CardTitle className="ps-3 pt-3">
                  <h2 className="mb-3 font-size-20">Actualizar cliente</h2>
                </CardTitle>
                <CardBody>
                  <Form onSubmit={onSubmit}>
                    <Row className="justify-content-md-center">
                      <Col lg={8}>
                        <p>Datos personales</p>
                      </Col>
                    </Row>
                    <Row className="justify-content-md-center">
                      <Col lg={3}>
                        <div className="form-floating mb-3">
                          <select
                            className="form-select"
                            id="document_type"
                            name="document_type"
                            value={document_type}
                            onChange={onChange}
                          >
                            <option value="CC">
                              Cédula de ciudadanía (CC)
                            </option>
                            <option value="NIT">
                              Número de identificación tributaria (NIT)
                            </option>
                          </select>
                          <Label for="document_type">
                            Tipo de identificación
                          </Label>
                        </div>
                      </Col>
                      <Col lg={5}>
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <i className="bx bx-id-card bx-sm" />
                          </span>
                          <div className="form-floating">
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Número de identificación"
                              name="document_number"
                              id="document_number"
                              value={document_number}
                              onChange={onChange}
                              {...(props.error && {
                                ...(props.error.document_number
                                  ? { invalid: true }
                                  : { valid: true }),
                              })}
                              required
                            />
                            <FormFeedback tooltip>
                              {props.error.document_number}
                            </FormFeedback>
                            <Label for="document_number">
                              Número de identificación
                            </Label>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row className="justify-content-md-center">
                      <Col lg={3}>
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <i className="bx bx-id-card bx-sm" />
                          </span>
                          <div className="form-floating">
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Código"
                              name="code"
                              id="code"
                              value={code}
                              onChange={onChange}
                              {...(props.error && {
                                ...(props.error.code
                                  ? { invalid: true }
                                  : { valid: true }),
                              })}
                              required
                            />
                            <FormFeedback tooltip>
                              {props.error.code}
                            </FormFeedback>
                            <Label for="code">Código</Label>
                          </div>
                        </div>
                      </Col>
                      <Col lg={5}>
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <i className="bx bx-id-card bx-sm" />
                          </span>
                          <div className="form-floating">
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Nombre completo"
                              name="full_name"
                              id="full_name"
                              value={full_name}
                              onChange={onChange}
                              {...(props.error && {
                                ...(props.error.full_name
                                  ? { invalid: true }
                                  : { valid: true }),
                              })}
                              required
                            />
                            <FormFeedback tooltip>
                              {props.error.full_name}
                            </FormFeedback>
                            <Label for="full_name">Nombre completo</Label>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row className="justify-content-md-center">
                      <Col lg={4}>
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <i className="bx bx-envelope bx-sm" />
                          </span>
                          <div className="form-floating">
                            <Input
                              type="email"
                              className="form-control"
                              placeholder="Email"
                              name="email"
                              id="email"
                              value={email}
                              onChange={onChange}
                              {...(props.error && {
                                ...(props.error.email
                                  ? { invalid: true }
                                  : { valid: true }),
                              })}
                              required
                            />
                            <FormFeedback tooltip>
                              {props.error.email}
                            </FormFeedback>
                            <Label for="email">Email</Label>
                          </div>
                        </div>
                      </Col>
                      <Col lg={4}>
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <i className="bx bx-phone bx-sm" />
                          </span>
                          <div className="form-floating">
                            <Input
                              type="tel"
                              className="form-control"
                              placeholder="Teléfono"
                              name="phone_number"
                              id="phone_number"
                              value={phone_number}
                              onChange={onChange}
                              {...(props.error && {
                                ...(props.error.phone_number
                                  ? { invalid: true }
                                  : { valid: true }),
                              })}
                              required
                            />
                            <FormFeedback tooltip>
                              {props.error.phone_number}
                            </FormFeedback>
                            <Label for="phone_number">Teléfono</Label>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row className="justify-content-md-center">
                      <Col lg={4}>
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <i className="bx bx-map-alt bx-sm" />
                          </span>
                          <div className="form-floating">
                            <Input
                              type="text"
                              style={{ textTransform: "uppercase" }}
                              className="form-control"
                              placeholder="Departamento"
                              name="department"
                              id="department"
                              value={department}
                              onChange={onChange}
                              {...(props.error && {
                                ...(props.error.department
                                  ? { invalid: true }
                                  : { valid: true }),
                              })}
                              required
                            />
                            <FormFeedback tooltip>
                              {props.error.department}
                            </FormFeedback>
                            <Label for="department">Departamento</Label>
                          </div>
                        </div>
                      </Col>
                      <Col lg={4}>
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <i className="bx bx-map-alt bx-sm" />
                          </span>
                          <div className="form-floating">
                            <Input
                              type="text"
                              style={{ textTransform: "uppercase" }}
                              className="form-control"
                              placeholder="Ciudad"
                              name="city"
                              id="city"
                              value={city}
                              onChange={onChange}
                              {...(props.error && {
                                ...(props.error.city
                                  ? { invalid: true }
                                  : { valid: true }),
                              })}
                              required
                            />
                            <FormFeedback tooltip>
                              {props.error.city}
                            </FormFeedback>
                            <Label for="city">Ciudad</Label>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row className="justify-content-md-center">
                      <Col lg={3}>
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <i className="bx bx-map bx-sm" />
                          </span>
                          <div className="form-floating">
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Dirección"
                              name="address"
                              id="address"
                              value={address}
                              onChange={onChange}
                              {...(props.error && {
                                ...(props.error.address
                                  ? { invalid: true }
                                  : { valid: true }),
                              })}
                              required
                            />
                            <FormFeedback tooltip>
                              {props.error.address}
                            </FormFeedback>
                            <Label for="address">Dirección</Label>
                          </div>
                        </div>
                      </Col>
                      <Col lg={5}>
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <i className="bx bx-store-alt bx-sm" />
                          </span>
                          <div className="form-floating">
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Establecimiento"
                              name="establishment"
                              id="establishment"
                              value={establishment}
                              onChange={onChange}
                              {...(props.error && {
                                ...(props.error.city
                                  ? { invalid: true }
                                  : { valid: true }),
                              })}
                            />
                            <FormFeedback tooltip>
                              {props.error.establishment}
                            </FormFeedback>
                            <Label for="establishment">Establecimiento</Label>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row className="justify-content-md-center">
                      <Col lg={8}>
                        <hr></hr>
                      </Col>
                    </Row>
                    <Row className="justify-content-md-center">
                      <Col lg={8}>
                        <p>Asignaciones</p>
                      </Col>
                    </Row>
                    <Row className="justify-content-md-center">
                      <Col lg={2}>
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <i className="bx bx-dollar bx-sm" />
                          </span>
                          <div className="form-floating">
                            <select
                              className="form-select"
                              id="rate"
                              name="rate"
                              value={rate}
                              onChange={onChange}
                            >
                              {rates.map((rate, idx) => (
                                <option key={idx} value={rate.id}>
                                  {rate.rate_value.toLocaleString("es-MX")}
                                </option>
                              ))}
                            </select>
                            <Label for="rate">Tarifa</Label>
                          </div>
                        </div>
                      </Col>
                      <Col lg={5}>
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <i className="bx bx-car bx-sm" />
                          </span>
                          <div className="form-floating">
                            <select
                              className="form-select"
                              id="vehicle"
                              name="vehicle"
                              value={vehicle}
                              onChange={onChange}
                            >
                              <option defaultValue value="">
                                -----
                              </option>
                              {vehicles.map((vehicle, idx) => (
                                <option
                                  key={idx}
                                  value={vehicle.id}
                                >{`${vehicle.plate} - ${vehicle.driver}`}</option>
                              ))}
                            </select>
                            <Label for="vehicle">Vehículo</Label>
                          </div>
                        </div>
                      </Col>
                      <Col lg={1} className="pt-3">
                        <Link to="/vehicles/create">
                          <span
                            className="bx bx-plus-circle bx-sm"
                            id="vehicle_add"
                          ></span>
                          <UncontrolledTooltip
                            placement="right"
                            target="vehicle_add"
                          >
                            Agregar vehículo nuevo
                          </UncontrolledTooltip>
                        </Link>
                      </Col>
                    </Row>
                    <Row className="justify-content-md-center mt-3 ms-5">
                      <Col lg={3}>
                        <Link className="btn btn-danger me-4" to="/clients">
                          Cancelar
                        </Link>

                        <Button color="success" type="submit">
                          Actualizar
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </div>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { error, loading, clientUpdated } = state.Client;
  return { error, loading, clientUpdated };
};

export default withRouter(connect(mapStateToProps)(ClientUpdate));
